import { Attributes, Misc, ModelBase, Validation } from '@singularsystems/neo-core';
import LetterAuthorisationSignatory from './LetterAuthorisationSignatory';

export default class LetterAuthorisationRequiredSignatory extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public letterAuthorisationRequiredSignatoryId: number = 0;

    public letterAuthorisationBatchId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public signatoryId: number | null = null;

    // Client only properties / methods

    @Attributes.DisplayMember()
    @Attributes.NoTracking()
    public name: string = "";

    @Attributes.NoTracking()
    public model: LetterAuthorisationSignatory | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New letter authorisation required signatory";
        } else {
            return "Letter Authorisation Required Signatory";
        }
    }
}